import { Box, Flex, Image, Text, VStack } from "@chakra-ui/react";
import { GalleriesLandingInterface } from "../../constants/Landing";
import { useDarkWhiteColor } from "../../themes/colors";
import BusinessRolesExplained from "./BusinesssRolesExplained";

const steps = [
  {
    title: "Daftar dan Unggah Produk",
    description:
      "UMKM mendaftar di platform BisnisLink.id dan melengkapi profilnya",
  },
  {
    title: "Reseller Memasarkan Produk",
    description:
      "Daftar dan dapatkan akses ke katalog produk. Pilih produk yang ingin dipasarkan",
  },
  {
    title: "Transaksi Lancar, Semua Untung!",
    description:
      "Pembeli melakukan pembayaran dengan aman lewat sistem BisnisLink.id. Produk dikirim langsung ke pembeli, jadi reseller nggak perlu stok barang.",
  },
];

const AppWorkflow = ({
  roleList,
  isRoleListDataLoading,
}: {
  roleList: GalleriesLandingInterface[] | undefined;
  isRoleListDataLoading: boolean;
}) => {
  const bgBnw = useDarkWhiteColor();

  return (
    <Flex direction={"column"} gap={"24px"}>
      <Box>
        <Text as={"h2"} textAlign={"center"}>
          <Text as={"span"} textStyle={"h-title"}>
            Cara Kerja
          </Text>
          &nbsp;
          <Text as={"span"} textStyle={"h-title"} color={"red.400"}>
            BisnisLink
          </Text>
        </Text>
        <Text
          maxW={"850px"}
          mx={"auto"}
          textAlign={"center"}
          mt={2}
          lineHeight={"18px"}
          textStyle={"b-reg"}
          variant={"secondary"}
        >
          BisnisLink menghubungkan UMKM sebagai supplier dengan reseller andal.
          Supplier dapat memasarkan produk mereka secara luas, sementara
          reseller membantu menjual produk secara online. Dengan sistem yang
          mudah, aman, dan transparan, BisnisLink menciptakan sinergi untuk
          mendorong pertumbuhan bisnis bagi semua pihak
        </Text>
      </Box>

      <Flex
        justify={"space-between"}
        alignItems={"center"}
        px={{ base: "0px", sm: "24px", md: "32px", lg: "40px", xl: "50px" }}
        gap={"16px"}
        mb={{ base: "4px", xl: "50px" }}
      >
        <Box as="figure" display={{ base: "none", md: "block" }} flex={"none"}>
          <Image
            src={"/assets/svg/illustration_carakerja.svg"}
            alt="Ilustrasi Bisnis BisnisLink"
            w={{ md: "280px", lg: "400px", xl: "553px" }}
            h={{ lg: "auto", xl: "352px" }}
            objectFit={"cover"}
          />
        </Box>

        <Box minW={{ base: "full", md: "350px" }} position={"relative"}>
          {steps.map((step, index) => (
            <Flex key={index} align="stretch" justify={"stretch"}>
              <Box display="flex" alignItems="center" justifyContent="center">
                <VStack position={"relative"} h={"full"} w={"40px"}>
                  <Box
                    width="2px"
                    bg="#F56565"
                    h={"full"}
                    zIndex={0}
                    flex={1}
                    position={"absolute"}
                    top={"0%"}
                    display={index === 0 ? "hidden" : "none"}
                  />

                  <Box
                    width="40px"
                    height="40px"
                    borderRadius="full"
                    bg={bgBnw}
                    border="2px solid #F56565"
                    color="#F56565"
                    fontWeight="bold"
                    position={"absolute"}
                    top={"0%"}
                    mt={"-0px"}
                    zIndex={1}
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                  >
                    {index + 1}
                  </Box>

                  <Box
                    width="2px"
                    bg={"#F56565"}
                    h={"full"}
                    zIndex={0}
                    flex={1}
                    position={"absolute"}
                    top={index === steps?.length - 1 ? "-50%" : "0%"}
                    display={
                      index === 0 || index === steps?.length - 1
                        ? "none"
                        : "hidden"
                    }
                  />
                </VStack>
              </Box>

              <Box ml={3} flexGrow={1} pb={5}>
                <Text textStyle={"b-reg-sb"}>{step.title}</Text>

                <Text textStyle={"b-sm"} variant={"secondary"}>
                  {step.description}
                </Text>
              </Box>
            </Flex>
          ))}
        </Box>
      </Flex>

      <BusinessRolesExplained
        roleList={roleList}
        isRoleListDataLoading={isRoleListDataLoading}
      />
    </Flex>
  );
};

export default AppWorkflow;
